module.exports = __webpack_public_path__ + "static/media/IC_carbon_emission.7bf5bf21.svg";